import { Field } from "formik"

function Input({ type, name, placeholder, component, className }) {
    return (
        <Field type={type} name={name} component={component} placeholder={placeholder} autoComplete="off" className={"resize-none outline-none w-full bg-transparent border-b border-type text-xl placeholder:text-type text-white pb-2 my-4 " + className} />
    )
}

export default Input